import type { FieldConfig, ValueState } from '../../types'

import { intlFormat } from '@/shared/tools/dates'

import { Operators } from '../../constants'
import FieldController from '../Controller'

export default class DateTimeRangeController extends FieldController {
	constructor(config: FieldConfig) {
		super(config)
		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.placeholder = config.placeholder || this.placeholder
	}
	placeholder = '__/__/____, _:_'

	hasValue = ({ value }: ValueState) => value?.length === 2

	getInitialValue = () => ({
		operation: Operators.DATE_BETWEEN,
		value: [],
	})
	formatState = ({ value }: ValueState) => ({
		operation: '',
		value: `${value?.[0] ? intlFormat(new Date(value[0]), { timeStyle: 'short', dateStyle: 'short' }) : this.placeholder} - ${value?.[1] ? intlFormat(new Date(value[1]), { timeStyle: 'short', dateStyle: 'short' }) : this.placeholder}`,
	})
	formatLabel = ({ value }: ValueState) =>
		`${value?.[0] ? intlFormat(new Date(value[0]), { timeStyle: 'short', dateStyle: 'short' }) : this.placeholder} - ${value?.[1] ? intlFormat(new Date(value[1]), { timeStyle: 'short', dateStyle: 'short' }) : this.placeholder}`
}
